import React, { useState } from 'react';

import { PureTranslator } from 'ggApp/modules/translator';
import { ResendCodeActions } from 'ggApp/modules/auth/v3/components/forms/TwoFactorAuthResendCode/ResendCodeActions';

import { StepWrapper, Title, Text, CapsHeadline, Button } from './styles';

const TwoFAHelp = ({ current, send, stepData }) => {
    const timestamp = current?.context?.phoneVerificationPending?.timeoutSeconds ?? null;
    const timeoutSeconds = current?.context?.phoneVerificationPending?.timeoutSeconds ?? null;
    const phoneLastDigits = current?.context?.phoneVerificationPending?.phoneLastDigits ?? null;
    const requestPayload = current?.context?.phoneVerificationPending?.requestPayload ?? null;

    const [resendCodeAvailableTime, setResendCodeAvailableTime] = useState(
        timestamp + timeoutSeconds * 1000,
    );

    const onResend = () => {
        send('RESEND_CODE', requestPayload);
    };

    return (
        <StepWrapper>
            <Title>
                <PureTranslator tk={stepData.heading} />
            </Title>
            <Text>
                <PureTranslator tk={stepData.subHeading} />
            </Text>
            <CapsHeadline>
                <PureTranslator tk="NEW_CHECKOUT_2FA_HELP_YOUR_NUMBER_HEADING" />
            </CapsHeadline>
            <Text>
                <PureTranslator
                    tk="NEW_CHECKOUT_2FA_HELP_YOUR_NUMBER_TEXT"
                    withValues={{ phoneLastDigits }}
                />
            </Text>
            <ResendCodeActions
                resendCodeAvailableTime={resendCodeAvailableTime}
                setResendCodeAvailableTime={setResendCodeAvailableTime}
                defaultTimeoutInSeconds={timeoutSeconds}
                onSubmit={onResend}
            />
            <Button type="button" fullWidth outlined onClick={() => send('BACK')}>
                <PureTranslator tk={stepData.buttonSecondary} />
            </Button>
        </StepWrapper>
    );
};

export default TwoFAHelp;
